import client, { baseClient } from '@/api/client'
import { notifyError } from '@/utils/appstore'

export async function getActivity(integrationType: string) {
    try {
        const { data } = await client.get(
            `/integration/${integrationType}/activity`
        )
        return data
    } catch (e: any) {
        let err = e.message
        if (e.response.data.message) {
            err = e.response.data.message
        }
        notifyError(`Something went wrong: ${err}`)
    }
}

export async function getDetail(integrationType: string, date: string) {
    try {
        const { data } = await client.get(
            `/integration/${integrationType}/activity/${date}`
        )
        return data
    } catch (e: any) {
        let err = e.message
        if (e.response.data.message) {
            err = e.response.data.message
        }
        notifyError(`Something went wrong: ${err}`)
    }
}

export async function getIntegrationData(integration: string) {
    try {
        const { data } = await baseClient.get(`/${integration}/settings`)
        return data
    } catch (e: any) {
        notifyError(`Something went wrong: ${e.message}`)
    }
}
